import { useId } from 'react';

/**
 * 버스인 로고 — 버스 앞모습 마크 + 글자(2026-09-29 way 「상단이 너무 텍스트만 있다 · 상품성」).
 * 마크는 `public/favicon.svg` 와 **같은 도형**이다(탭 아이콘과 화면 로고가 한 몸으로 보이게 — 바꾸면 둘 다).
 * 색은 brand 토큰(담당자 웹 = 파랑)을 따른다 — 기사앱(html.driver-app)에선 자동으로 보라가 된다.
 *   bar  = 상단 메뉴줄(높이 32px 안 — 메뉴가 두 줄로 접히지 않게 폭을 옛 글자와 비슷하게 둔다)
 *   hero = 로그인 카드
 */
export function BrandMark({ size = 32 }: { size?: number }) {
  // useId 는 `:r1:` 처럼 콜론이 낀다 — url(#…) 참조에서 깨지는 브라우저가 있어 뺀다. 로고가 두 개여도 그라데이션이 안 겹친다.
  const id = `bm${useId().replace(/:/g, '')}`;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden className="shrink-0 drop-shadow-sm">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" style={{ stopColor: 'rgb(var(--brand-500))' }} />
          <stop offset="1" style={{ stopColor: 'rgb(var(--brand-700))' }} />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${id})`} />
      <rect x="6" y="5.5" width="20" height="21" rx="6" fill="#ffffff" />
      <rect x="8.8" y="8.6" width="14.4" height="7" rx="2.6" style={{ fill: 'rgb(var(--brand-600))' }} />
      <g style={{ fill: 'rgb(var(--brand-600))' }}>
        <circle cx="10.9" cy="19.6" r="1.7" />
        <circle cx="21.1" cy="19.6" r="1.7" />
        <rect x="9.2" y="22.6" width="13.6" height="2.1" rx="1.05" />
      </g>
    </svg>
  );
}

export default function BrandLogo({ variant = 'bar' }: { variant?: 'bar' | 'hero' }) {
  if (variant === 'hero') {
    return (
      <div className="flex flex-col items-center gap-3">
        <BrandMark size={56} />
        <div>
          <div className="text-2xl font-extrabold tracking-tight text-ink">
            버스인<span className="text-brand-600">.</span>
          </div>
          <div className="mt-1 text-sm text-ink-soft">동영관광 배차·정산 시스템</div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex select-none items-center gap-2">
      <BrandMark size={30} />
      <div className="leading-none">
        <div className="text-[15px] font-extrabold tracking-tight text-ink">
          버스인<span className="text-brand-600">.</span>
        </div>
        <div className="mt-[3px] text-[10px] font-semibold tracking-[0.14em] text-brand-600/80">동영관광</div>
      </div>
    </div>
  );
}
